export const Constants = {
  storage: {
    keys: {
      profileImage: "profileImage",
      feedbackBanner: "feedbackBanner",
      selectedLanguage: "selectedLanguage",
      firstSignIn: "firstSignIn",
    },
    expiry: {
      profileImage: 10, //10mins
      feedbackBanner: 1440, //1day,
    },
    values: {
      profileImage404Value: "404",
    },
  },
  navigation: {
    urls: {
      home: "/",
      profile: "/profile",
      account: "/account",
      language: "/language",
      feedback: "/feedback",
      lacAiAgent: "/communities/lac-ai-agent",
      dailyHuddleDocument: "/daily-huddle/document",
      dailyHuddleFacilities: "/daily-huddle/facilities",
    },
  },
  translationKeys: {
    welcome_banner_greeting: "welcome_banner_greeting",
    feedback_banner_title: "feedback_banner_title",
    feedback_banner_text_before_link: "feedback_banner_text_before_link",
    feedback_banner_link_text: "feedback_banner_link_text",
    feedback_banner_text_after_link: "feedback_banner_text_after_link",
    my_dashboard_title: "my_dashboard_title",
    other_key_sites_title: "other_key_sites_title",
    sticky_nav_home: "sticky_nav_home",
    sticky_nav_ai_chat: "sticky_nav_ai_chat",
    sticky_nav_ai_note: "sticky_nav_ai_note",
    sticky_nav_account: "sticky_nav_account",
    header_title_account: "header_title_account",
    header_title_profile: "header_title_profile",
    header_title_language: "header_title_language",
    header_title_feedback: "header_title_feedback",
    not_available: "not_available",
    sign_in: "sign_in",
    sign_out: "sign_out",
    continue: "continue",
    skip: "skip",
    next: "next",
    get_started: "get_started",
    language_page_title: "language_page_title",
    language_page_subtitle: "language_page_subtitle",
    langauge_alert_title: "langauge_alert_title",
    langauge_alert_content: "langauge_alert_content",
    welcome_screen_1_title: "welcome_screen_1_title",
    welcome_screen_1_text: "welcome_screen_1_text",
    welcome_screen_3_title: "welcome_screen_3_title",
    welcome_screen_3_text: "welcome_screen_3_text",
    welcome_screen_4_title: "welcome_screen_4_title",
    welcome_screen_4_text: "welcome_screen_4_text",
    welcome_screen_5_title: "welcome_screen_5_title",
    welcome_screen_5_text: "welcome_screen_5_text",
  },
  appInfo: {
    text: "App Version 1.0.1 Uniting NSW/ACT",
  },
  language: {
    languageItems: [
      { key: "en", value: "English" },
      { key: "zh-CN", value: "Chinese (Simplified) (简体中文)" },
      { key: "zh-TW", value: "Chinese (Traditional) (繁體中文)" },
      { key: "hi", value: "Hindi (हिन्दी)" },
      { key: "id", value: "Indonesian (Bahasa Indonesia)" },
      { key: "ne", value: "Nepali (नेपाली)" },
      { key: "es", value: "Spanish (Español)" },
    ],
  },
  welcomeScreens: [
    { key: "welcome", value: "1", image: "welcome"},
    { key: "language", value: "2"},
    { key: "myDashboard", value: "3", image: "my-dashboard"},
    { key: "aiChat", value: "4", image: "ai-chat"},
    { key: "aiNotes", value: "5", image: "ai-note"},
  ],
  profileDataListItems: [
    { key: "displayName" },
    { key: "jobTitle" },
    { key: "mail" },
    { key: "directorate" },
    { key: "stream" },
    { key: "officeLocation" },
  ],
  accountDataListItems: [
    {
      key: "profile",
      items: [
        {
          type: "routerLink",
          key: "show_profile",
          icon: "",
          secondaryActionIcon: "arrow_forward",
          link: "profile",
        },
      ],
    },
    {
      key: "settings",
      items: [
        {
          type: "routerLink",
          key: "select_language",
          icon: "language",
          secondaryActionIcon: "arrow_forward",
          link: "language",
        },
        {
          type: "externalLink",
          key: "change_uniting_password",
          icon: "lock",
          secondaryActionIcon: "arrow_forward",
          link: "https://mysignins.microsoft.com/security-info/password/change",
        },
      ],
    },
    {
      key: "feedback",
      items: [
        {
          type: "routerLink",
          key: "provide_feedback",
          icon: "thumb_up",
          secondaryActionIcon: "open_in_new",
          link: "feedback",
        },
      ],
    },
    {
      key: "help",
      items: [
        {
          type: "walkthrough",
          key: "launch_walkthrough",
          icon: "",
          secondaryActionIcon: "play",
        },
        {
          type: "externalLink",
          key: "learn_about_buddy",
          icon: "",
          secondaryActionIcon: "open_in_new",
          link: "https://uniting.sharepoint.com/sites/DigitalAssistant",
        },
        {
          type: "externalLink",
          key: "raise_ticket_ESH",
          icon: "",
          secondaryActionIcon: "open_in_new",
          link: "https://employeeserviceshub.uniting.org/esc?id=esc_dashboard",
        },
        {
          type: "tell",
          key: "call_service_desk",
          icon: "",
          secondaryActionIcon: "call",
          link: "tel:+611300751145",
        },
      ],
    },
    {
      key: "legal",
      items: [
        {
          type: "externalLink",
          key: "ai_policy",
          icon: "",
          secondaryActionIcon: "open_in_new",
          link: "https://uniting.sharepoint.com/sites/PoliciesAndPractice/Policies/Forms/Recent.aspx?id=%2Fsites%2FPoliciesAndPractice%2FPolicies%2FUniting%20Artificial%20Intelligence%20Policy%2Epdf&parent=%2Fsites%2FPoliciesAndPractice%2FPolicies",
        },
        {
          type: "externalLink",
          key: "information_policy",
          icon: "",
          secondaryActionIcon: "open_in_new",
          link: "https://uniting.sharepoint.com/sites/PoliciesAndPractice/Policies/Forms/Recent.aspx?id=%2Fsites%2FPoliciesAndPractice%2FPolicies%2FUniting%20Information%20Security%20Policy%2Epdf&parent=%2Fsites%2FPoliciesAndPractice%2FPolicies",
        },
        {
          type: "externalLink",
          key: "privacy_policy",
          icon: "",
          secondaryActionIcon: "open_in_new",
          link: "https://uniting.sharepoint.com/sites/PoliciesAndPractice/Policies/Forms/Recent.aspx?id=%2Fsites%2FPoliciesAndPractice%2FPolicies%2FUniting%20Privacy%20Policy%2Epdf&parent=%2Fsites%2FPoliciesAndPractice%2FPolicies",
        },
        {
          type: "externalLink",
          key: "privacy_confidentiality_procedure",
          icon: "",
          secondaryActionIcon: "open_in_new",
          link: "https://uniting.sharepoint.com/sites/PoliciesAndPractice/_layouts/15/viewer.aspx?sourcedoc=%7Bde43fffa-18d5-4b74-8888-329d2e406212%7D",
        },
      ],
    },
  ],
};
